import { Button } from "@chakra-ui/react";
import { PlusIcon } from "lib/icons/plusIcon";
import { packsClient } from "lib/clients";
import { useToastNotification } from "lib/hooks";
import { mutate } from "swr";
import { FC } from "react";
import { useRouter } from "next/router";

export const CreatePackButton: FC<{ parent?: string }> = ({ parent }) => {
  const { errorToast } = useToastNotification();
  const router = useRouter();

  const create = async (): Promise<void> => {
    try {
      const { data } = await packsClient.createPack({ title: 'Untitled Pack', superpack_id: parent });
      await mutate('/v1/packs');
      await router.push(`/packs/${data.id}`);
    } catch (e) {
      errorToast({ title: 'Error', description :'Could not create new pack' });
    }
  }

  return (
    <Button size={"sm"} onClick={create} leftIcon={<PlusIcon boxSize={"12px"} />} variant="light">
      {parent ? 'Add' : 'Create'} a new pack
    </Button>
  )
}
